import React from "react";

//assets
import contact_canada from "../../assets/images/canada.png";
import contact_uk from "../../assets/images/uk.png";
import contact_australia from "../../assets/images/austrila.png";
import contact_dubai from "../../assets/images/dubai.png";
import contact_india from "../../assets/images/india.png";

const Midpart = (props) => {
    const locations = {
        usa:  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54352.13903864183!2d74.83510089172034!3d31.633612449880022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391964aa569e7355%3A0xeea2605bee84ef7d!2sAmritsar%2C%20Punjab!5e0!3m2!1sen!2sin!4v1655209193487!5m2!1sen!2sin",

        ldh: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54352.13903864183!2d74.83510089172034!3d31.633612449880022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391964aa569e7355%3A0xeea2605bee84ef7d!2sAmritsar%2C%20Punjab!5e0!3m2!1sen!2sin!4v1655209193487!5m2!1sen!2sin",

        aus: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54352.13903864183!2d74.83510089172034!3d31.633612449880022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391964aa569e7355%3A0xeea2605bee84ef7d!2sAmritsar%2C%20Punjab!5e0!3m2!1sen!2sin!4v1655209193487!5m2!1sen!2sin",

        afr:  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54352.13903864183!2d74.83510089172034!3d31.633612449880022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391964aa569e7355%3A0xeea2605bee84ef7d!2sAmritsar%2C%20Punjab!5e0!3m2!1sen!2sin!4v1655209193487!5m2!1sen!2sin",

        can:  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54352.13903864183!2d74.83510089172034!3d31.633612449880022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391964aa569e7355%3A0xeea2605bee84ef7d!2sAmritsar%2C%20Punjab!5e0!3m2!1sen!2sin!4v1655209193487!5m2!1sen!2sin",

        nod:  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54352.13903864183!2d74.83510089172034!3d31.633612449880022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391964aa569e7355%3A0xeea2605bee84ef7d!2sAmritsar%2C%20Punjab!5e0!3m2!1sen!2sin!4v1655209193487!5m2!1sen!2sin",
    };
    const [url, setPar] = React.useState(locations.ldh);

    return (
        <section className="contact_alt_midpart_section">
            <div className="container-fluid p-0">
                <div
                    data-aos="fade-up"
                    data-aos-delay="1000"
                    className="map"
                >
                <iframe
                    className="frame"
                    src={url}
                    width="100%"
                    height="450"
                    allowFullScreen=""
                    loading="lazy"
                ></iframe>
             </div>
            </div>
            <div className="cont">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="midpart_area">
                                <div className="locations">
                                    <div className="row">
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div
                                                data-aos="fade-up"
                                                className="place"
                                            >
                                                <img
                                                    src={contact_canada}
                                                    alt="..."
                                                />
                                                <div className="content">
                                                    <p
                                                        className="ad"
                                                        onClick={() =>
                                                            setPar(locations.nod)
                                                        }
                                                    >
                                                        4-840 Kingsway Ave SE, Medicine Hat, AB T1A 8G5

                                                    </p>
                                                    <span className="ph">
                                                        <i className="fas fa-phone-alt"></i>
                                                        <p>
                                                            <a href="tel:+91-123456789">
                                                                +91-123456789
                                                            </a>
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div
                                                data-aos="fade-up"
                                                data-aos-delay="200"
                                                className="place"
                                            >
                                                <img
                                                    src={contact_australia}
                                                    alt="..."
                                                />
                                                <div className="content">
                                                    <p
                                                        className="ad"
                                                        onClick={() =>
                                                            setPar(locations.ldh)
                                                        }
                                                    >
                                                        Lorem ipsum dolor sit amet consectetur
                                                        Lorem ipsum dolor sit amet consectetur, 
                                                    </p>
                                                    <span className="ph">
                                                        <i className="fas fa-phone-alt"></i>
                                                        <p>
                                                            <a href="tel:+91-123456789">
                                                                +91-123456789
                                                            </a>
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div
                                                data-aos="fade-up"
                                                data-aos-delay="400"
                                                className="place"
                                            >
                                                <img
                                                    src={contact_india}
                                                    alt="..."
                                                />
                                                <div className="content">
                                                    <p
                                                        className="ad"
                                                        onClick={() =>
                                                            setPar(locations.usa)
                                                        }
                                                    >
                                                        1474, Street No. 2, Sharifpura, Amritsar, Punjab.
                                                    </p>
                                                    <span className="ph">
                                                        <i className="fas fa-phone-alt"></i>
                                                        <p>
                                                            <a href="tel:+91-123456789">
                                                                +91-123456789
                                                            </a>
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div
                                                data-aos="fade-up"
                                                data-aos-delay="200"
                                                className="place"
                                            >
                                                <img
                                                    src={contact_dubai}
                                                    alt="..."
                                                />
                                                <div className="content">
                                                    <p
                                                        className="ad"
                                                        onClick={() =>
                                                            setPar(locations.can)
                                                        }
                                                    >
                                                        Lorem ipsum dolor sit amet consectetur
                                                        Lorem ipsum dolor sit amet consectetur, 
                                                    </p>
                                                    <span className="ph">
                                                        <i className="fas fa-phone-alt"></i>
                                                        <p>
                                                            <a href="tel:+91-123456789">
                                                                +91-123456789
                                                            </a>
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div
                                                data-aos="fade-up"
                                                data-aos-delay="400"
                                                className="place"
                                            >
                                                <img
                                                    src={contact_uk}
                                                    alt="..."
                                                />
                                                <div className="content">
                                                    <p
                                                        className="ad"
                                                        onClick={() =>
                                                            setPar(locations.aus)
                                                        }
                                                    >
                                                        Lorem ipsum dolor sit amet consectetur
                                                        Lorem ipsum dolor sit amet consectetur, 
                                                    </p>
                                                    <span className="ph">
                                                        <i className="fas fa-phone-alt"></i>
                                                        <p>
                                                            <a href="tel:+91-123456789">
                                                                +91-123456789
                                                            </a>
                                                        </p>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="rearward_area">
                                    <div
                                        data-aos="fade-up"
                                        data-aos-anchor-placement="center-bottom"
                                        className="ban"
                                    >
                                        <form>
                                            <p
                                                data-aos="fade-up"
                                                data-aos-delay="400"
                                            >
                                                Leave a comment
                                            </p>
                                            <div className="row">
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div
                                                        data-aos="fade-up"
                                                        data-aos-delay="200"
                                                        className="topleft_area"
                                                    >
                                                        <label className="boxes">
                                                            <i className="fas fa-user icon"></i>
                                                            First Name:
                                                            <input type="text"></input>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div
                                                        data-aos="fade-up"
                                                        data-aos-delay="300"
                                                        className="topright_area"
                                                    >
                                                        <label className="boxes">
                                                            <i className="fas fa-user icon"></i>
                                                            last Name:
                                                            <input type="text"></input>
                                                        
                                                                <p className="valid-helper">
                                                                    
                                                                </p>
                                                        
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div
                                                        data-aos="fade-up"
                                                        data-aos-delay="200"
                                                        className="topleft_area"
                                                    >
                                                        <label className="boxes">
                                                            <i className="fas fa-phone-alt icon"></i>
                                                            Phone:
                                                            <input
                                                                type="number"
                                                            
                                                            ></input>
                                                        
                                                                <p className="valid-helper">
                                                                
                                                                </p>
                                                        
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                                                    <div
                                                        data-aos="fade-up"
                                                        data-aos-delay="300"
                                                        className="topright_area"
                                                    >
                                                    <label className="boxes">
                                                            <i className="fas fa-envelope icon"></i>
                                                            Email:
                                                            <input
                                                                type="email"
                                                            
                                                            ></input>
                                                        
                                                                <p className="valid-helper">
                                                                
                                                                </p>
                                                        
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                                    <div
                                                        data-aos="fade-up"
                                                        data-aos-delay="400"
                                                        className="botarea"
                                                    >
                                                    <label className="boxes">
                                                            <i className="fas fa-envelope icon"></i>
                                                            Message:
                                                            <textarea
                                                                type="text"
                                                                placeholder="Write your Message"
                                                                
                                                            ></textarea>
                                                        
                                                                <p className="valid-helper">
                                                                
                                                                </p>
                                                        
                                                        </label>
                                                        <div className="submit">
                                                            <div className="secondary_btn nav-item"><button type="button" className="btn btn-outline-primary">Contact Us</button></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Midpart;
